import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';
import { useEffect } from 'react';

import { useJobPostingContext } from '@/contexts/job-posting-context';
import { useIsFirstJobPostOnAccount } from '@/hooks/use-is-first-job-post-on-account';
import { usePostHog } from '@/hooks/use-posthog';
import { queryKeys } from '@/query-keys';

import { Card } from './card';

interface SourcingRecommendationProps {
  isExpanded: boolean;
  onCountChange: (count: number) => void;
}

export function SourcingRecommendation({
  isExpanded,
  onCountChange,
}: SourcingRecommendationProps) {
  const { openJobPostingForm } = useJobPostingContext();
  const posthog = usePostHog();
  const isFirstJobPostOnAccount = useIsFirstJobPostOnAccount();

  const {
    data: { opening_ids: suggestedOpeningIds },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.dashboard.recommendations.sourcing],
    queryFn: () =>
      SourcingService.getInternalApiSourcingDashboardSourcingRecommendation(),
  });

  const hasRecommendations =
    !!suggestedOpeningIds && suggestedOpeningIds.length > 0;

  useEffect(() => {
    onCountChange(hasRecommendations ? 1 : 0);
  }, [hasRecommendations, onCountChange]);

  if (!isExpanded || !hasRecommendations) return null;

  const handlePostJobClick = () => {
    posthog.capture('source_post_job:button_click', {
      entry_point: 'sponsored_postings',
      is_first_job_post_on_account: isFirstJobPostOnAccount,
    });
    openJobPostingForm({
      openings: suggestedOpeningIds.map(id => ({ id })),
      entryPoint: 'sponsored_postings',
    });
  };

  return (
    <Card
      recommendationType="SOURCING"
      onClick={handlePostJobClick}
      value={suggestedOpeningIds.length}
    />
  );
}
